<template>
  <b-container >
    <b-card-body v-if="thankYouPage" style="text-align:center">
      Hvala na kupovini. Kupljene usluge ce odmah biti omogućene u okviru platforme. Ukoliko imate nekih pitanja molimo kontaktirajte našu korisničku podršku.
      <b-button v-if="user" variant="primary" to="/admin/dashboard" class="mt-3"> {{ $t('backToPlatform') }} </b-button>
      <b-button v-else variant="primary" to="/login" class="mt-3"> {{ $t('signIn') }} </b-button>
    </b-card-body>
    <b-card-body v-else>
      <b-row v-if="billingAddress">
        <b-col cols="12" md="8" style="padding: 20px">
          <b-form @submit="onSubmit" :key="billingAddress.type">
            <b-form-group label="Tip subjekta">
              <b-form-select
                v-model="billingAddress.type"
                :options="options"
                variant="dark"
                required
              ></b-form-select>
            </b-form-group>

            <b-form-group v-if="billingAddress.type === 'person'" label="Ime">
              <b-form-input v-if="billingAddress.type === 'person'"
                v-model="billingAddress.firstname"
                type="text"
                placeholder="Unesi Ime"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group v-if="billingAddress.type === 'person'" label="Prezime">
              <b-form-input v-if="billingAddress.type === 'person'"
                v-model="billingAddress.lastname"
                type="text"
                placeholder="Unesi Prezime"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group v-if="billingAddress.type === 'company'" label="PIB">
              <b-form-input
                v-model="billingAddress.vat_number"
                type="text"
                placeholder="PIB"
                required
              ></b-form-input>
            </b-form-group>

            <template v-if="showOtherFields">
              <b-form-group v-if="billingAddress.type === 'company'" label="Matični broj">
                <b-form-input
                  v-model="billingAddress.main_number"
                  type="text"
                  placeholder="Matični broj"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group v-if="billingAddress.type === 'company'" label="Puno ime pravnog lica">
                <b-form-input v-if="billingAddress.type === 'company'"
                  v-model="billingAddress.company"
                  type="text"
                  placeholder="Puno ime pravnog lica"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Email">
                <b-form-input
                  v-model="billingAddress.email"
                  type="email"
                  placeholder="Unesi email"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Adresa">
                <b-form-input
                  v-model="billingAddress.address"
                  type="text"
                  placeholder="Adresa"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Grad">
                <b-form-input
                  v-model="billingAddress.city"
                  type="text"
                  placeholder="Grad"
                  required
                ></b-form-input>
              </b-form-group>
            </template>
            <b-form-group v-if="billingAddress.type === 'company'" label="Način plaćanja">
              <b-row>
                  <b-col>
                      <b-form-checkbox name="type" value="invoice" v-model="paymentMethod" :disabled="true"
                      > Faktura </b-form-checkbox>
                  </b-col>
              </b-row>
            </b-form-group>
            <b-row style="margin-top: 15px">
              <b-col cols="12">     
                <b-button class="float-right" variant="primary" type="submit">Završi kupovinu </b-button> 
                
              </b-col>
              <b-col style="text-align:right;color:#ccc" class="mt-2" v-if="TPERIOD !== null && TPERIOD !== '0' && TPERIOD !== ''">
                <span> Probni period od {{ this.TPERIOD }} dana. </span>
              </b-col>
            </b-row>
          </b-form>

       </b-col>
        <b-col cols="12" md="4">
          <b-row cols="3" style="border-bottom-style: dashed; padding-bottom: 20px; margin-bottom: 15px">
            <b-col>
              <span class="mt-3" v-for="(name, idx) in prodNames" style="display: block" :key="name"><strong>{{ name }} <small v-if="prodOptions[idx]">( {{ prodOptions[idx] }} )</small></strong> x {{ quantities[idx] }}
                <br />
                <small>{{ prices[idx] }} RSD</small>
              </span>
            </b-col>
          </b-row>
          <b-row class="float-right" v-if="this.total !== undefined">
            <span>Ukupno: {{ this.total.toFixed(2) }} RSD</span>
          </b-row>
        </b-col>
      </b-row>
    </b-card-body>
  </b-container>
</template>

<script>
import _ from 'lodash'
import publicHttp from '../../shared/publicHttp'

export default {
  name: "Index",
  data: function () {
    return {
      user: null,
      name: null,
      email: null,
      address: null,
      city: null,
      pib: null,
      nationalId: null,
      selected: null,
      prodNames: null,
      quantities: null,
      prices: null,
      total: null,
      prodOptions: null,
      PRODS: null,
      PROD_NAMES: null,
      GROUPS: null,
      PRICES: null,
      TPERIOD: null,
      PHASH: null,
      QTY: null,
      PROD_OPTIONS: null,
      options: [
        { value: 'company', text: 'Pravno Lice' },
        { value: 'person', text: 'Fizičko Lice' },
      ],
      thankYouPage: false,
      billingAddress: null,
      paymentMethod: 'invoice',
      showOtherFields: false
    }
  },
  watch: {
    'billingAddress.vat_number': function(n, o) {
        if (n.length == 9) {
          this.$integrationApi.get("/invoicing/services/nbs/search?vatNumber=" + n).then((resp) => {
            let info = resp.data

            this.billingAddress.main_number = info.mb
            this.billingAddress.company = info.name
            this.billingAddress.address = info.address
            this.billingAddress.city = info.place
          }).catch(() => {
             if (o && o.length != 0) {
              this.$bvToast.toast('Nismo uspeli da pronadjemo podatke. Molimo vas popunite formu.', {
                title: 'Greška',
                variant: 'danger'
              })
            }
          })
          .finally(() => {
            this.showOtherFields = true
          })
        }
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const popup = this.$loadingPopup()

      this.$transactionApi.post("/checkout/protokol/order", this.billingAddress, {
        params: this.$route.query
      }).then(() => {
        this.thankYouPage = true
        this.$gtag.purchase({
          transaction_id: 'unknown',
          affiliation: "Serbia checkout",
          value: this.total
        })

        let checkoutPage = new BroadcastChannel('checkout')
        checkoutPage.postMessage({
          type: "checkout_finished"
        })
      }).catch(() => {
        this.$bvModal.msgBoxOk("Došlo je do greške, pokušajte ponovo kasnije. Ako se greška nastavi, molimo vas kontaktirajte korisničku podršku.", {
          okOnly: true,
        })
      }).finally(() => {
        popup.hide()
      })
    }
  },
  computed: {},  
  async mounted() {
    this.$gtag.event('checkout_started')

    try {
      let resp = await publicHttp.get("/user/model")
      this.user = resp.data
      this.billingAddress = this.user.settings.billing_address
    } catch(err) {
      //
      this.billingAddress = {
        type: 'company',
        firstname: '',
        lastname: '',
        address: '',
        city: '',
        zipcode: '',
        country: 'Serbia',
        company: '',
        vat_number: '',
        main_number: '',
        email: ''
      }
    }

    let query = this.$route.query;
    this.PRODS = query.PRODS;
    this.PROD_NAMES = query.PROD_NAMES;
    this.GROUPS = query.GROUPS;
    this.PRICES = query.PRICES;
    this.TPERIOD = query.TPERIOD;
    this.QTY = query.QTY;
    this.PHASH = query.PHASH;
    this.TPERIOD = query.TPERIOD
    this.PROD_OPTIONS = query.OPTIONS

    this.prodNames = this.PROD_NAMES.split(',').map(s => s.trim());
    this.quantities = this.QTY.split(',').map(s => s.trim());
    this.prices = this.PRICES.split(',').map(s => s.trim());
    this.prodOptions = this.PROD_OPTIONS.split(",").map(s => s.trim());

    let result = query.QTY.split(',').map(s => s.trim()).map(function(value, index) {
      return [query.QTY.split(',').map(s => s.trim())[index], query.PRICES.split(',').map(s => s.trim())[index]];
    });

    for (let i = 0; i < result.length; i++) {
      this.total += parseInt(result[i][0]) * parseInt(result[i][1]);
    }
  }
}
</script>